module.exports = __webpack_public_path__ + "img/first_bg01.00877082.png";